export const CONTRACTOR_ENTITY_LABEL = "Contractor";
export const CONTRACTOR_ENTITY_LABEL_PLURAL = "Contractors";
/** Lower-case form, for the middle of a sentence. */
export const CONTRACTOR_ENTITY_LABEL_PLURAL_LOWER = "contractors";

export const CONTRACTOR_BATCH_DELETE_DESCRIPTION =
  "This batch has contractors data but no contractors are created yet.";
export const CONTRACTOR_BATCH_DELETE_EMPTY_DESCRIPTION =
  "This batch is empty. No contractors are imported yet.";
